import "./../styles/reset.scss";
import "./../styles/style.scss";

// Page load event handlers

window.addEventListener("DOMContentLoaded", () => {
  // sets brightness of the background
  document.getElementById("container").style.filter = "brightness(100%)";
});
